export default {
  title: 'Partner Deduplication',
  subtitle: 'Review and merge duplicate business partners detected by Meilisearch.',
  scan_now: 'Scan now',
  scanning: 'Scanning...',
  scan_started: 'Scan queued. New candidates will appear once the job finishes.',
  auto_merge: 'Auto-merge {count} obvious',
  auto_merge_done: 'Auto-merge complete. Merged: {merged}, skipped: {skipped}.',
  auto_merge_confirm: {
    title: 'Auto-merge obvious duplicates',
    body: 'This will merge {count} pairs that have a perfect name match (score ≥ 0.98) AND identical address. Keeper is picked automatically: most foreign-key references → oldest → most populated. Continue?',
    confirm: 'Merge all',
  },
  no_candidates: 'No duplicate candidates pending review.',
  threshold: 'Match threshold',
  refresh: 'Refresh',
  search_placeholder: 'Search by partner name, legal name or invoicing name…',
  score: 'Score',
  diff_legend: 'Green = identical to keeper, orange = differs, grey = only one side has it.',
  cluster: {
    header: '{count} duplicate(s) detected for this partner',
    score_range: 'Score range: {min} – {max}',
    keeper_label: 'Keeper (suggested)',
    keeper_badge: 'KEEPER',
    select_all: 'Select all {count}',
    merge_selected: 'Merge selected ({count})',
    review_pair: 'Review',
    merge_help: 'Bulk merge auto-resolves all conflicts in favor of the keeper. To pick per field (address, settings, checklists), use "Review" on a specific row.',
    confirm_body: '{count} partner(s) will be merged into the keeper. Each merge transfers FKs and soft-deletes the loser. Continue?',
    confirm_body_with_winners: '{count} partner(s) will be merged into the keeper, with {overrides} field(s) overridden by your picks. Continue?',
    pick_winner_tooltip: 'Use this value on the keeper after merge',
    keeper_overridden: 'Will become',
    scope_shared: 'Shared · all companies',
    scope_company: 'Only · {name}',
    will_become_shared: '→ will become Shared',
    scope_summary_title: 'Company scope',
    scope_summary_keeper_shared: 'Keeper is shared across all companies. Result stays shared.',
    scope_summary_keeper_company: 'Keeper belongs to {name} only. Result stays scoped to {name} unless cross-company losers are selected.',
    scope_summary_will_demote: 'Keeper currently scoped to {current}, but selected losers are shared or from another company → result will become shared across all companies.',
    supplier_hint_title: 'All transactions are purchase bills',
    supplier_hint_body: 'All {count} transaction(s) tied to this cluster are bills. The keeper looks like a supplier rather than a client.',
    convert_to_supplier: 'Convert keeper to Supplier',
    type_changed_to_supplier: 'Keeper type changed to Supplier.',
    merge_done: 'Cluster merged. Success: {merged}, failed: {failed}.',
  },
  oldest_badge: 'oldest',
  counts: {
    transactions: 'Tx',
    service_calls: 'Calls',
    lease_contracts: 'Leases',
    part_options: 'Supply',
    transaction_items: 'Sold',
  },
  fields: {
    name: 'Name',
    legal_name: 'Legal',
    invoicing_name: 'Invoicing name',
    email: 'Email',
    phone: 'Phone',
    billing_address: 'Billing address',
    shipping_address: 'Shipping address',
    created_at: 'Created',
    updated_at: 'Last updated',
    last_transaction_at: 'Last tx',
  },
  actions: {
    keep_left: 'Keep left',
    keep_right: 'Keep right',
    keep_suggested: 'Keep (suggested)',
    not_a_duplicate: 'Not a duplicate',
  },
  confirm: {
    title: 'Confirm merge',
    body: 'The losing partner will be soft-deleted and all of its references (transactions, leases, addresses, contacts, tags) will be moved to the keeper. This cannot be undone from the UI.',
    keeper: 'Keeper',
    loser: 'Loser',
    confirm: 'Merge',
    cancel: 'Cancel',
    loading: 'Checking for conflicts...',
    no_conflicts: 'No conflicts. Loser data will be transferred or silently dropped if identical.',
    conflicts_title: '{count} field(s) differ — pick the value to keep',
    use_keeper: 'Keep keeper value',
    use_loser: 'Use loser value',
    drops_note: '{count} identical row(s) will be silently discarded:',
  },
  errors: {
    merge_failed: 'Merge failed: {message}',
    scan_failed: 'Could not start scan: {message}',
    load_failed: 'Could not load candidates: {message}',
  },
}
